import {reactive} from "vue";
import type {EmpresaDescontoVm} from "@/domain/type/empresaDesconto.type";

class EmpresaDescontoEvents {

    listenerEmpresaDescontoGravado = reactive({value: {empresaDescontoId: ''}})
    listenerEmpresaDescontoAdicionado = reactive({value: {empresaDescontoId: ''}})
    listenerEmpresaDescontoAlterado = reactive({value: {empresaDescontoId: ''}})
    listenerEmpresaDescontoCargoAlterado = reactive({value: {empresaDesconto: {} as EmpresaDescontoVm}})
    listenerEmpresaDescontoRemovido = reactive({value: {empresaDescontoId: ''}})
    listenerEmpresaDescontoCargoRemovido = reactive({value: {empresaDescontoId: ''}})
    listenerCancelarAlteracao = reactive({value: {empresaDescontoId: ''}})
    listenerEmpresaDescontoColaboradorGravado = reactive({value: {empresaDescontoColaboradorId: ''}})
    listenerEmpresaDescontoColaboradorRemovido = reactive({value: {empresaDescontoColaboradorId: ''}})

    emitEmpresaDescontoGravado(empresaDescontoId: string) {
        this.listenerEmpresaDescontoGravado.value = {empresaDescontoId: empresaDescontoId}
    }
    emitEmpresaDescontoAdicionado(empresaDescontoId: string) {
        this.listenerEmpresaDescontoAdicionado.value = {empresaDescontoId: empresaDescontoId}
    }

    emitEmpresaDescontoAlterado(empresaDescontoId: string) {
        this.listenerEmpresaDescontoAlterado.value = {empresaDescontoId: empresaDescontoId}
    } 
    emitEmpresaDescontoCargoAlterado(empresaDesconto: EmpresaDescontoVm) {
        this.listenerEmpresaDescontoCargoAlterado.value = {empresaDesconto: empresaDesconto}
    }

    emitEmpresaDescontoRemovido(empresaDescontoId: string) {
        this.listenerEmpresaDescontoRemovido.value = {empresaDescontoId: empresaDescontoId}
    } 
    emitEmpresaDescontoCargoRemovido(empresaDescontoId: string) {
        this.listenerEmpresaDescontoCargoRemovido.value = {empresaDescontoId: empresaDescontoId}
    }

    emitlistenerCancelarAlteracao(empresaDescontoId: string) {
        this.listenerCancelarAlteracao.value = {empresaDescontoId: empresaDescontoId}
    }


    emitEmpresaDescontoColaboradorGravado(empresaDescontoColaboradorId: string) {
        this.listenerEmpresaDescontoColaboradorGravado.value = {empresaDescontoColaboradorId: empresaDescontoColaboradorId}
    }

    emitEmpresaDescontoColaboradorRemovido(empresaDescontoColaboradorId: string) {
        this.listenerEmpresaDescontoColaboradorRemovido.value = {empresaDescontoColaboradorId: empresaDescontoColaboradorId}
    }

}

export default EmpresaDescontoEvents;